<template>
	<div v-if="enabled" 	
		class="filters-container" 
		>
		<!-- <pre> -->
			<!-- x: {{ ( tableFiltersEnabled && tableFilters ) || search }} -->
		<!-- </pre> -->
	    <div v-if="(tableFiltersEnabled && tableFilters )" class="dropdown-filters" id="dropdown-filters">
	    
	        <span class="caption-uppercase">{{ feTheme.filters ?? 'FILTERS:' }}</span>

	        <DataviewFiltersDropdowns 
	        		:dtPost="dtPost"
	        		:tableFilters="tableFilters"
	        		:feTheme="feTheme"
	        		:side="filtersPosition == 'filters-position-side'"
	        		:softFilterArgument="softFilterArgument"
	        		@filterSubmit="filterSubmit"
	        	/>
	    
	    </div>
	    <div v-else></div>

    	<template v-if="dateFilters">
		    <DataviewFiltersDatepicker 
		    	:dtPost="dtPost"
		    	:feTheme="feTheme"
		    	:dateFilters="dateFilters"
		    	@dateUpdate="submitDateFilters"
		    />
		</template>

        <template v-if="vw">
            <ViewWrapperToggle
                :feTheme="feTheme"
                @wrapperToggleUpdate="wrapperToggleUpdate"
            />
        </template>
<!--         <pre>-->
<!--         vw: {{ ( vw )}}-->
<!--         </pre>-->

	    <!-- {% if vw and filters_position == 'filters-position-top' %}
	        {% include 'common/_view-wrapper-toggle.twig' %}
	    {% endif %} -->

	</div><!--/.filters-container-->

</template>


<script>
import { wrapperToggleUpdate } from '@vueapp/lib/common'

import ViewWrapperToggle from '@vueapp/components/view-wrappers/ViewWrapperToggle.vue'

import DataviewFiltersDropdowns from '@vueapp/components/dataviews/DataviewFiltersDropdowns.vue'
import DataviewFiltersDatepicker from '@vueapp/components/dataviews/DataviewFiltersDatepicker.vue'

export default {

	props: {
		'dtPost': Object, 
		'tableFilters': Array, 
		'search': Array, 
		'vw': Boolean, 
		'feTheme': {
			type: Object,
			default: {}
		},
		'tableFiltersEnabled': {
			type: Boolean,
			default: false
		},
		'filtersPosition': String,
		'dateFilters': Object,
		softFilterArgument: Object
	},
	components: {
		DataviewFiltersDropdowns,
		DataviewFiltersDatepicker,
        ViewWrapperToggle
	},

	created() {
		// console.log('inputDark::', inputDark)

		this.wrapperToggleUpdate = wrapperToggleUpdate

		const filters = {},
            _this = this
        if ( this.softFilterArgument ) {
            for ( let key in this.softFilterArgument ) {

            	this.tableFilters.map( item => {
            		if ( item.column_name == key ) {
            			filters[key] = this.softFilterArgument[key]
            			item.active = true
            			console.log('item::', item)
            		}
            		return item
            	})
            }
            if ( filters ) {
            	this.filters = {...this.filters, ...filters}
            	this.$emit('filters-submit', this.filters)	
            }
            

            // setTimeout(function() {
            //     console.log(filters)
            //     // _this.filtersSubmit(filters)

            // }, 10)
        }        

	},

    data() {
        return {
        	startDate: '',
        	endDate: '',
        	filters: {},
        }
    },

    emits: ['filters-submit'],

    computed: {
    	enabled() {
    		// console.log('enabled::', this.dtPost.enable_filters_bar && ( this.tableFilters || this.search || this.vw ) )
    		return this.tableFiltersEnabled && ( this.tableFilters || this.search || this.vw ) || this.dateFilters 
    	}
    },

    updated() {
    	if ( this.filters ) {
    		let changed = false
    		for ( let filter_c in this.filters ) {
    			let l = this.tableFilters.filter( item => item.active && item.column_name == filter_c )
    			if ( ! l.length ) {
    				this.filters[filter_c] = ''
    				delete this.filters[filter_c]
    				changed = true
    			}
    		}
    		!changed || this.$emit('filters-submit', this.filters)
	    }
    },

    methods: {
    	filterSubmit(e) {
			this.filters[e.filterKey] = e.filterValue
			this.$emit('filters-submit', this.filters)
    	},

    	submitDateFilters(range) {
			let payload = {'time-interval': !range || 2 != range.length ? [this.start_date, this.end_date] : ( range.map( item => item/1000) ).join('|') }
			this.filters = { ...this.filters, ...payload }
			this.$emit('filters-submit', this.filters)    		
    	},
    	// wrapperToggleUpdate( e) {
		// 	return this.wrapperToggleUpdate
    	// }
    }
    
}
</script>

<style scoped>
.filters-container {
	justify-content: space-between;
    align-items: center;
}
</style>